import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";
import { fetchApi } from "../../../../lib/fetchApi";
import { SelectItemDto } from "../../../../types/SelectItemDto";

export const mapToDemandInFormat = mapDictionaryState;

const demandInFormatApi = createDictionaryApiFactory("demandInFormat");

export const getDemandInFormat = demandInFormatApi.search;
export const getDemandInFormatDetail = demandInFormatApi.getDetail;
export const createDemandInFormat = demandInFormatApi.save;
export const exportCsvDemandInFormat = demandInFormatApi.exportCsv;

export const getDemandInFormatSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/demandInFormat/select`) as SelectItemDto[];
    return response;
};
